<template>
    <div class="container tercero-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{labels.title}}</h2>
        </div>
        <!-- <pre>{{ contrato }}</pre> -->
        <div class="tercero-table-block mt-4" v-if="contrato.length > 0">
            <CorporateDataTable
                :items="contratoFormat"
                :fields="allFields"
                :filter-defs="tableFilterDefs"                
                :default-per-page="10"
                :page-options="[10, 15, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
            ></CorporateDataTable>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5> 
        </div>
    </div>
</template>

<script>
import CorporateDataTable from '../utils/CorporateDataTable.vue'
import Contrato from '../../services/Contrato.js';
export default {
    name : 'ConsultarDetalle',
    components : {CorporateDataTable},
    data(){
        return {
            contrato : []
        }
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Detalle',
                    noRow : 'No hay registros',
                    contrato : 'Contrato',
                    fechaInicial : 'Fecha inicial',
                    fechaFinal : 'Fecha final',
                    modalidad : 'Modalidad',
                    valorCanon : 'Valor canon',
                    frecuencia : 'Frecuencia',
                    estado : 'Estado',
                    filterContrato : 'Filtrar contrato...',
                    filterFechaInicial : 'Filtrar fecha inicial...',
                    filterFechaFinal : 'Filtrar fecha final...',
                    filterValCanon : 'Filtrar valor canon...',
                    filterFrecuencia : 'Filtrar frecuencia...',
                    filterModalidad : 'Filtrar modalidad...',
                    filterEstado : 'Filtrar estado...',
                }
            }else{
                return {
                    title : 'Detail',
                    noRow : 'No records found',
                    contrato : 'Contract',
                    fechaInicial : 'Start date',
                    fechaFinal : 'End date',
                    modalidad : 'Modality',
                    valorCanon : 'Fee amount',
                    frecuencia : 'Frequency',
                    estado : 'State',
                    filterContrato : 'Filter contract...',
                    filterFechaInicial : 'Filter by start date...',
                    filterFechaFinal : 'Filter by end date...',
                    filterValCanon : 'Filter by base amount...',
                    filterFrecuencia : 'Filter frequency...',
                    filterModalidad : 'Filter by mode...',
                    filterEstado : 'Filter by status...',
                }
            }
        },
        allFields(){
            return [
                { key: 'nro_contrato', label: this.labels.contrato, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'fecha_inicial', label: this.labels.fechaInicial, sortable: true, thClass: 'text-center', tdClass: 'text-start' },
                { key: 'fecha_final', label: this.labels.fechaFinal, sortable: true, thClass: 'text-center', tdClass: 'text-start' },
                { key: 'modalidad', label: this.labels.modalidad, sortable: true, thClass: 'text-center', tdClass: 'text-start' },
                { key: 'canon_arrendamiento', label: this.labels.valorCanon, sortable: true, thClass: 'text-center', tdClass: 'text-end' },
                { key: 'frecuencia', label: this.labels.frecuencia, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'estado', label: this.labels.estado, sortable: true, thClass: 'text-center', tdClass: 'text-start' },
            ]
        },
        tableFilterDefs(){
            return [
                { key: 'nro_contrato', type: 'text', placeholder: this.labels.filterContrato },
                { key: 'fecha_inicial', type: 'text', placeholder: this.labels.filterFechaInicial },
                { key: 'fecha_final', type: 'text', placeholder: this.labels.filterFechaFinal },
                { key: 'modalidad', type: 'text', placeholder: this.labels.filterModalidad },
                { key: 'canon_arrendamiento', type: 'text', placeholder: this.labels.filterValCanon },
                { key: 'frecuencia', type: 'text', placeholder: this.labels.filterFrecuencia },
                { key: 'estado', type: 'text', placeholder: this.labels.filterEstado },
            ]
        },
        contratoFormat() {
            return this.contrato.map(item => ({
                ...item,
                modalidad: this.typeModalidad(item.modalidad),
                canon_arrendamiento: this.formatNumber(item.canon_arrendamiento)
            }));
        }
    },
    methods:{
        goBack(){
            this.$router.back()
        },
        typeModalidad(modalidad) {
            switch (modalidad) {
                case 'V':
                    return 'Vencida';
                case 'F':
                    return 'Fija';
                case 'A':
                    return 'Anticipada';
                default:
                    return modalidad;
            }
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 })?.format(value); 
        },
    },
    mounted() {
        const id = this.$route.params.id;

        Contrato.getContratoById(id)
        .then(res => {
            // console.log(res.data.contractById[0]);
            this.contrato = [res.data.contractById[0]];
        });
    }
}
</script>

<style>

</style>